import React, { useState, useEffect, useRef } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ModalComponent from "../reusable Component/modalComponent";
import { GET_LEAD_BY_BDM_API, PENDING_AND_COLD_LEAD } from "../../constants";
import Box from "@mui/material/Box";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import WavesIcon from "@mui/icons-material/Waves";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import LockIcon from "@mui/icons-material/Lock";
import axios from "axios";
import {
  Alert,
  Button,
  Fab,
  Menu,
  MenuItem,
  Snackbar,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import Loader from "../reusable Component/Loader";
import { useTheme } from "@emotion/react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import moment from "moment";
import { useLocation } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import BdmMobileLeadlist from "./BdmMobileLeadList";
import BdmMainLeadTableComponent from "./BdmMainLeadTableList";
// show hide button states ------->
import {useContext} from 'react';
import { ButtonVisibilityContext } from '../../Context/ButtonVisibilityContext';
// child imported -->  BgmMobileLeatlist


function BdmTabComponent() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();

  // show hide add lead float button
  const {showButton} = useContext(ButtonVisibilityContext);


  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (location.state && location.state.tab !== undefined) {
      setValue(location.state.tab);
    }
  }, [location.state]);

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const [hotLeadCount, setHotCountLead] = useState(0);
  const [warmLeadCount, setWarmCountLead] = useState(0);
  const [coldLeadCount, setColdCountLead] = useState(0);
  const [pendingLeadCount, setPendingCountLead] = useState(0);
  const [closedLeadCount, setClosedCountLead] = useState(0);
  const [allLeadCount, setAllLeadCount] = useState(0);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [severity, setSeverity] = useState("");
  const [message, setMessage] = useState("");

  const [loading, setLoading] = useState(false);

  const [runEffect, setRunEffect] = useState(false);

  const empId = localStorage.getItem("username");


  const formatDate = (dateString) => moment(dateString).format("DD-MM-YYYY");

  const [editMobNo, setEditMobNo] = useState("");

  return (
    <>
      {loading && <Loader open={loading} />}
      <Box
        sx={{
          display: isMobile ? "flex" : "",
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "stretch" : "center",
          justifyContent: isMobile ? "center" : "space-between",
          padding: isMobile ? "0px" : "16px",
        }}
      >
        {/* Regular Button for non-mobile view */}
        {!isMobile && (
          <Button
            variant="outlined"
            onClick={handleClickOpen}
            sx={{
              fontSize: "1rem",
              fontWeight: "700",
              borderWidth: "1.5px",
              marginBottom: 0,
              float: "right",
            }}
          >
            + Add Lead
          </Button>
        )}

        {/* Floating Action Button for mobile view */}
             {isMobile && (
  showButton ? (
    <Box
      sx={{
        position: "fixed",
        bottom: `calc(16px + ${isMobile ? "80px" : "0px"})`,
        right: 16,
        zIndex: 10,
      }}
    >
      <div>
        <Fab
          color="primary"
          aria-label="add lead"
          onClick={handleClickOpen}
          sx={{
            backgroundColor: "primary",
            "&:hover": {
              backgroundColor: "#115293",
            },
          }}
        >
          <AddIcon />
        </Fab>
      </div>
    </Box>
  ) : (
    <>
    </>
  )
)}
        <ModalComponent
          open={open}
          modalTitle={"BDM Lead Generation"}
          setOpen={setOpen}
          rowDetails={{}}
          setOpenSnackbar={setOpenSnackbar}
          setSeverity={setSeverity}
          setMessage={setMessage}
          setEditMobNo={setEditMobNo}
        ></ModalComponent>
       {isMobile ? (
          <BdmMobileLeadlist></BdmMobileLeadlist>
        ) : (
          <BdmMainLeadTableComponent></BdmMainLeadTableComponent>
        )}

      </Box>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000} // Snackbar will auto hide after 6 seconds
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={severity}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default BdmTabComponent;
